const getOpportunityValue = ticket => {
  const fields = ticket.contact?.extraInfo || [];
  const f = fields.find(x => x.name === 'valor');
  return f ? parseFloat(f.value) : 0;
};

const buildBoardData = (lanes, searchText, filterUserId, filterQueueId) => ({
  lanes: lanes.map(lane => ({
    id: lane.id.toString(),
    title: lane.title,
    color: lane.color,
    label: '',
    currentPage: 1,
    cards: lane.tickets
      .filter(ticket => {
        if (filterUserId && ticket.user?.id !== filterUserId) return false;
        if (filterQueueId && ticket.queue?.id !== filterQueueId) return false;
        if (searchText) {
          const s = searchText.toLowerCase();
          const name = (ticket.contact?.name || '').toLowerCase();
          const msg = (ticket.lastMessage || '').toLowerCase();
          if (!name.includes(s) && !msg.includes(s)) return false;
        }
        return true;
      })
      .map(ticket => ({
        id: ticket.id.toString(),
        title: ticket.contact?.name || '',
        description: ticket.lastMessage || '',
        opportunityValue: getOpportunityValue(ticket),
        ticket,
        laneId: lane.id.toString(),
      })),
  })),
});

export default buildBoardData;
export { getOpportunityValue };
